import { ReactNode } from "react";
import ModalComponent from "..";
import { ModalCompProps } from "../../../utils/types";
import { Button, ButtonVariations } from "../../buttons/button";

export const ConfirmationModal = ({
  open,
  handleClose,
  title,
  subtitle,
  onProceed,
  loading,
  children,
  cancelText = "Cancel",
  proceedText = "Confirm",
  proceedVariation = "primary",
}: ModalCompProps & {
  title?: string;
  subtitle?: string;
  onProceed: () => void;
  loading: boolean;
  children?: ReactNode;
  cancelText?: string;
  proceedText?: string;
  proceedVariation?: ButtonVariations;
}) => {
  return (
    <ModalComponent
      open={open}
      handleClose={handleClose}
      className="md:!max-w-[400px]"
      dialogClassName=""
      closeOnOverlayClick
      showHeader
      title={title}
      subtitle={subtitle}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      {children}
      <div className="col-span-full grid w-full grid-cols-2 items-center justify-end gap-2">
        <Button
          text={cancelText}
          type="button"
          onClick={() => {
            handleClose();
          }}
          variation="plain-grey"
          className="order-last md:order-first md:flex-1"
        />
        <Button
          text={proceedText}
          type="button"
          onClick={onProceed}
          className=""
          loading={loading}
          disabled={loading}
          variation={proceedVariation}
        />
      </div>
    </ModalComponent>
  );
};
